import { PostEditorReducerFunction, PostEditorRemovePostGroupAction } from '../PostEditorActions';
import { InitialPostEditorState } from '../initial';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';

export const removeGroupReducer: PostEditorReducerFunction<PostEditorRemovePostGroupAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const postGroupIndex = payload;
  const result = updateImmutable(state, {
    postGroups: {
      [postGroupIndex]: {
        deleted: { $set: true },
        errors: { $set: InitialPostEditorState().postGroups[0].errors }
      }
    }
  });
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning);
};
